import { render, staticRenderFns } from "./Questions.vue?vue&type=template&id=cc0b0390&scoped=true"
import script from "./Questions.vue?vue&type=script&lang=ts"
export * from "./Questions.vue?vue&type=script&lang=ts"
import style0 from "./Questions.vue?vue&type=style&index=0&id=cc0b0390&prod&lang=scss&scoped=true"
import style1 from "./Questions.vue?vue&type=style&index=1&id=cc0b0390&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0b0390",
  null
  
)

export default component.exports